import { render, staticRenderFns } from "./ProductCategoryCombobox.vue?vue&type=template&id=69272c07&scoped=true"
import script from "./ProductCategoryCombobox.vue?vue&type=script&lang=js"
export * from "./ProductCategoryCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69272c07",
  null
  
)

export default component.exports